import Vue from 'vue'
import { Tooltip, Tag } from 'ant-design-vue'

Vue.use(Tooltip)
Vue.use(Tag)

export default Vue.extend({
  // LPA-9: the only column using this renderer is autoHeight + wrapText, so the
  // messages stay multi-line; the tooltip exposes the full list regardless of width.
  template: `
        <div>
          <a-tooltip placement="right">
            <template slot="title">
              <div v-for="msg in list" :key="msg">{{ msg }}</div>
            </template>
            <div>
              <div class="pb-1" v-for="msg in list" :key="msg">
                <span> {{ msg }} </span>
              </div>
            </div>
          </a-tooltip>
        </div>
      `,
  data: function() {
    return {
      list: [],
    }
  },
  beforeMount() {
    this.list = this.params.value || []
  },
})
